import { required, schema } from '@angular/forms/signals';

import { StudyFormValue } from './study-form.types';

/** Study Label and Study Description are optional free-text fields — only `study_name` and `study_status_key` are required by `StudyCreateRequestBody`. */
export const STUDY_FORM_SCHEMA = schema<StudyFormValue>(schemaPath => {
    required(schemaPath.name, { message: 'Study name is required.' });
    required(schemaPath.status, { message: 'Study status is required.' });
});
